import { Link } from "react-router-dom";
import { BsFillTrashFill } from "react-icons/bs";

function TableComponent({id, headers, body, data, skip, link, needOptions = false}){
    return (
        <table id={id} className="list-table my-3">
            <thead>
                <tr>
                    <th>#</th>
                    {headers.map((header, index) => (
                        <th key={index}>{header}</th>
                    ))}
                    {needOptions &&
                        <th></th>
                    }
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td> <Link to={`${link}${item._id}`}>{ (index+1) + skip }</Link> </td>
                        {body.map((bodyItem, bodyIndex)=>(
                            <td key={`${index}${bodyIndex}`}> <Link to={`${link}${item._id}`} className={`${bodyItem.classname}`}>{item[bodyItem.data]}</Link> </td>
                        ))}
                        {needOptions &&
                            <td>
                                <BsFillTrashFill className='trash-icon' />
                            </td>
                        }
                    </tr> 
                ))}
            </tbody>
        </table>
    )
}

export default TableComponent;